import { Routes } from '@angular/router';

export const POTENCIALES_PROYECTOS_ROUTES: Routes = [
  {
    path: 'listar',
    loadComponent: () =>
      import('./listar/potenciales-proyectos-listar.component')
        .then(m => m.PotencialesProyectosListarComponent)
  },
  {
    path: 'crear',
    loadComponent: () =>
      import('./crear/potenciales-proyectos-crear.component')
        .then(m => m.PotencialesProyectosCrearComponent)
  },
  {
    path: 'editar/:id',
    loadComponent: () =>
      import('./editar/potenciales-proyectos-editar.component')
        .then(m => m.PotencialesProyectosEditarComponent)
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detalle/potenciales-proyectos-detalle.component')
        .then(m => m.PotencialesProyectosDetalleComponent)
  }
];
